export default function Contacts() {
  return (
    <main className="sec-content">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="contacts-block">
            <h1 className="contacts-block__title title-def title-def_sec2 color-g">Контакты</h1>
            <div className="wrap-article-2 contacts-block__text">
              <p>Телефон: <a href="tel+74996382624">+7 (499) 638-26-24</a></p>
              <p>Адрес: проезд Одоевского, д.3, корп.7<br/>117574, Москва</p>
              <p>Email: <a href="mailto:it@rutesil.ru">it@rutesil.ru</a></p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}